export default "__VITE_ASSET__CjBh1HIz__"